/**
 * Builds the complete list of text data items for the "Outdoor Lighting Report" template.
 * It takes separate objects for each data category and maps their properties to the correct placeholder IDs.
 * @param {object} projectDetails - An object containing details about the project.
 * @param {object} generalData - An object containing general data for the layout report page.
 * @param {object} outdoorResults - An object containing the calculation results (Eav, Emin, Emax, etc.).
 * @returns {Array<object>} The structured list of text data items for the API request.
 */
export const buildTextDataList = (projectDetails = {}, outdoorResults = {}, user = {}, generalData = {}) => {
  // Generate today's date in the format "DD Month YYYY"
  const today = new Date();
  const formattedDate = `${today.getDate()} ${today.toLocaleString('default', { month: 'long' })} ${today.getFullYear()}`;

  return [
    // Page 1, 2, & 3 - Project Details (shared across pages)
    { id: "report-date", text: formattedDate },
    { id: "designer-name", text: projectDetails.designer ?? 'N/A' },
    { id: "designer-name", text: user.userName ?? 'N/A' },
    { id: "project-no", text: projectDetails.projectNo ?? 'N/A' },
    { id: "project-name", text: projectDetails.projectName ?? 'N/A' },

    // Page 2 - General Data
    { id: "grid-origin", text: generalData.gridOrigin ?? 'N/A' },
    { id: "area-size", text: generalData.areaSize ?? 'N/A' },
    { id: "sample-spacing", text: generalData.sampleSpacing ?? 'N/A' },

    // Page 3 - Results Table
    { id: "value_eav", text: `${outdoorResults.eav ?? '0.00'} lux` },
    { id: "value_emin", text: `${outdoorResults.emin ?? '0.00'} lux` },
    { id: "value_emax", text: `${outdoorResults.emax ?? '0.00'} lux` },
    { id: "value_emin_emax", text: `${outdoorResults.emin_emax ?? '0.00'}` },
    { id: "value_emin_eav", text: `${outdoorResults.emin_eav ?? '0.00'}` },
  ];
};